
export const getAllAttachmentAs = state => state.attachmentAs.items;
